/* eslint-disable */

import React from "react";
import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import routes from "routes.js";

import logo from "../../assets/img/LIUKIT.svg";
import { Link } from "react-router-dom";

const Sidebar = ({ open, onClose }) => {
  // Обработчик клика вне сайдбара для мобильных устройств
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && window.innerWidth < 1024) {
      onClose();
    }
  };

  // Обработчик клавиши Escape
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && open && window.innerWidth < 1024) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [open, onClose]);

  return (
    <>
      {/* Затемнение фона для мобильных устройств */}
      {open && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={handleBackdropClick}
        />
      )}
      <div
        className={`sm:none duration-175 rounded-[20px] md:mt-4 md:m-2 box-border linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
          open ? "translate-x-0" : "-translate-x-96"
        }`}
      >
      <span
        className="absolute top-8 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX className="w-8 h-8"/>
      </span>

      <div className={`mr-[60px] ml-[30px] md:mx-[20px] mt-[20px] flex items-center`}>
        <Link to={'/'} className="mt-1 ml-1 h-2.5 font-poppins text-[30px] font-bold uppercase text-navy-700 dark:text-white">
          <img src={logo} alt="logo" className="w-full max-w-[180px]"  width={180}/>
        </Link>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <Links routes={routes} onLinkClick={onClose} />
      </ul>

      {/* Nav item end */}
    </div>
    </>
  );
};

export default Sidebar;
